/**
 * React to URL changes and update the language switcher links accordingly
 *
 * @param switchClass The CSS class that identifies the language switch anchor tag container
 */
class LanguageSwitch {
  readonly switchClass: string;

  private readonly switchLinks: { [lang: string]: HTMLAnchorElement } = {};

  constructor(switchClass: string) {
    this.switchClass = switchClass;
  }

  /**
   * Get available languages from language switch and add event listener to the `htmx:afterRequest` event
   */
  public init(): void {
    this.getSupportedLanguagesAndSwitchers();

    // the navigation links are cached, so we need to update them when the user accesses a jobs detail page
    this.updateLanguageSwitchUrls()

    document.addEventListener("htmx:afterRequest", () => this.updateLanguageSwitchUrls());
  }

  /**
   * Get a list of all supported languages from the language switcher and save the switcher links
   */
  private getSupportedLanguagesAndSwitchers(): void {
    document.querySelectorAll<HTMLAnchorElement>(`${this.switchClass} a[hreflang]`).forEach(link => {
      const language = link.getAttribute("hreflang");
      this.switchLinks[language] = link;
    });
  }

  /**
   * Update the language switch URLs with the new URI
   */
  private updateLanguageSwitchUrls(): void {
    const path = document.location.pathname;
    // construct the new URL from the second `/` onwards
    const newUrl = path.substring(path.indexOf("/", 1)) + document.location.search;

    Object.keys(this.switchLinks).forEach(lang => {
      this.switchLinks[lang].setAttribute("href", `/${lang}${newUrl}`);
    });
  }
}

/**
 * Update language switcher links after HTMX request to match the new URL
 */
export default LanguageSwitch;
